export const APP_ROLES = {
  ADMIN: "admin",
  USER: "user",
};
export let defaultData={
  "id": 1,
  "serial_number": "D9N224300409",
  "account_number": "8ee3d9ee2163329abae8fd6c5c2fb3cd",
  "is_default": true,
  "friendly_name":"Sickening Z1"
}